/*
  Enigma Store — Custom Scripts
  Design System: Emil Kowalski × Linear × Luxury K-Beauty
  ─────────────────────────────────────────────────────────
  Reglas Emil:
  · Solo animar transform + opacity (GPU layer)
  · Hover gated a @media (hover: hover)
  · Duraciones: 100ms press, 250ms normal, 400ms modal
  · Easing: cubic-bezier(0.23, 1, 0.32, 1) para entradas
*/


/* ══ 1. BTN-PRIMARY: Fill de abajo hacia arriba ══════════
   CSS background-position shift en mousedown/touchstart
   ════════════════════════════════════════════════════════ */
(function(){
  function triggerFill(btn){
    if(!btn) return;
    btn.classList.remove('btn--filling');
    void btn.offsetWidth;
    btn.classList.add('btn--filling');
    setTimeout(function(){ btn.classList.remove('btn--filling'); }, 650);
  }
  document.addEventListener('mousedown', function(e){
    triggerFill(e.target.closest('.btn-primary'));
  });
  document.addEventListener('touchstart', function(e){
    triggerFill(e.target.closest('.btn-primary'));
  }, { passive: true });
})();


/* ══ 2. SCROLL REVEAL — Emil stagger ════════════════════
   IntersectionObserver con threshold 0.12.
   Soporte para grupos (clase .reveal-group) con stagger CSS.
   ════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  /* Observar .reveal existentes */
  function observeReveals(){
    document.querySelectorAll('.reveal:not(.visible)').forEach(function(el){
      observer.observe(el);
    });
  }

  /* Observar grupos: primero el wrapper, luego los hijos */
  var groupObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        /* Activar hijos con stagger progresivo */
        var children = entry.target.querySelectorAll('.reveal');
        children.forEach(function(child, i){
          setTimeout(function(){
            child.classList.add('visible');
          }, i * 60);
        });
        groupObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.06 });

  document.querySelectorAll('.reveal-group').forEach(function(group){
    groupObserver.observe(group);
  });

  observeReveals();
  document.addEventListener('enigma:sections-updated', observeReveals);
})();


/* ══ 3. MAGNETIC CTAs — Sutil efecto imán ═══════════════
   Solo en desktop (hover: hover). Offset máximo: 14px.
   El botón sigue el cursor suavemente dentro de su zona.
   Emil: pequeños detalles que se sienten premium sin verse.
   ════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  /* Solo en dispositivos con hover real */
  if(!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var MAGNETIC_STRENGTH  = 0.22;
  var MAGNETIC_SELECTORS = '.enigma-btn-primary, .enigma-btn-secondary, .kb-btn-white, .kb-btn-ink';

  function initMagnetic(){
    document.querySelectorAll(MAGNETIC_SELECTORS).forEach(function(btn){
      if(btn.dataset.magneticInit) return;
      btn.dataset.magneticInit = '1';

      btn.addEventListener('mousemove', function(e){
        var rect   = btn.getBoundingClientRect();
        var cx     = rect.left + rect.width  / 2;
        var cy     = rect.top  + rect.height / 2;
        var dx     = (e.clientX - cx) * MAGNETIC_STRENGTH;
        var dy     = (e.clientY - cy) * MAGNETIC_STRENGTH;

        btn.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
        btn.style.transition = 'transform 180ms cubic-bezier(0.23, 1, 0.32, 1)';
      });

      btn.addEventListener('mouseleave', function(){
        btn.style.transform  = '';
        btn.style.transition = 'transform 350ms cubic-bezier(0.23, 1, 0.32, 1)';
      });

      /* Press feedback */
      btn.addEventListener('mousedown', function(){
        btn.style.transform  = 'scale(0.97)';
        btn.style.transition = 'transform 160ms ease';
      });
      btn.addEventListener('mouseup', function(){
        btn.style.transition = 'transform 350ms cubic-bezier(0.23, 1, 0.32, 1)';
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initMagnetic);
  } else {
    initMagnetic();
  }
})();


/* ══ 4. CART BADGE — Actualización en tiempo real ════════
   Llama /cart.js y actualiza el badge del navbar.
   Expuesta globalmente para que otros scripts la usen.
   ════════════════════════════════════════════════════════ */
// Contador de articulos del header.
//
// Apuntaba a #enigma-cart-badge, del navbar a medida. Con el navbar del tema
// el contador es .cart-count-badge y hay dos en la pagina --barra movil y
// iconos de escritorio--, asi que hay que recorrerlos todos.
//
// Hace falta porque refreshCartContents solo reemplaza nodos del cajon y de
// /cart: el header no viaja en esa respuesta y se quedaria con el numero de
// antes hasta recargar la pagina. El tema base tampoco lo actualiza.
//
// El tema marca el cero con el atributo hidden, no con una clase.
window.enigmaUpdateCartBadge = window.enigmaUpdateCartBadge || function(){
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var badges = document.querySelectorAll('.cart-count-badge, #enigma-cart-badge');
      if(!badges.length) return;
      var count = cart.item_count || 0;
      badges.forEach(function(badge){
        badge.textContent = count;
        if(count > 0){
          badge.removeAttribute('hidden');
          badge.classList.remove('is-hidden');
        } else {
          badge.setAttribute('hidden', 'hidden');
          badge.classList.add('is-hidden');
        }
      });
    })
    .catch(function(){});
};


/* ══ 5. SMOOTH ANCHOR SCROLL — respeta nav height ════════
   Compensa la navbar fija al hacer scroll a secciones.
   ════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  document.addEventListener('click', function(e){
    var link = e.target.closest('a[href^="#"]');
    if(!link) return;

    var id     = link.getAttribute('href').slice(1);
    if(!id) return;
    var target = document.getElementById(id);
    if(!target) return;

    e.preventDefault();

    var navH   = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 72;
    var extra  = 20;
    var top    = target.getBoundingClientRect().top + window.scrollY - navH - extra;

    window.scrollTo({ top: top, behavior: 'smooth' });
  });
})();


/* ══ 6. IMAGE LAZY LOAD — fade in premium ════════════════
   Imágenes con loading="lazy" hacen fade cuando cargan.
   ════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  function fadeLazy(img){
    if(img.complete) return;
    img.style.opacity = '0';
    img.style.transition = 'opacity 400ms cubic-bezier(0.23, 1, 0.32, 1)';
    img.addEventListener('load', function(){
      img.style.opacity = '1';
    }, { once: true });
  }

  document.querySelectorAll('img[loading="lazy"]').forEach(fadeLazy);
})();


/* ══ 7. HERO STAGGER — anima elementos en secuencia ══════
   Para .enigma-hero-content y .kb-hero-text que ya tienen
   animación CSS, este bloque añade stagger a sus hijos.
   ════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  function staggerHeroChildren(){
    var containers = document.querySelectorAll(
      '.enigma-hero-left, .kb-hero-left'
    );
    containers.forEach(function(container){
      var children = container.children;
      Array.prototype.forEach.call(children, function(child, i){
        child.style.animationDelay = (i * 80) + 'ms';
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', staggerHeroChildren);
  } else {
    staggerHeroChildren();
  }
})();


/* ══ 8. AFFILIATION TRACKING (ecomgraduates) ════════════ */
function addRefParamToUrlsAndSetCookie(){
  var urlParams = new URLSearchParams(window.location.search);
  var refParam  = urlParams.get('ref');

  if(!refParam){
    var cookies = document.cookie.split(';');
    for(var i = 0; i < cookies.length; i++){
      var cookie = cookies[i].trim();
      if(cookie.startsWith('ref=')){
        refParam = cookie.substring(4);
        break;
      }
    }
  }

  if(refParam){
    document.cookie = 'ref=' + refParam + '; expires=' + new Date(Date.now() + 30 * 24 * 60 * 60 * 1000) + '; path=/';
    var links = document.getElementsByTagName('a');
    for(var j = 0; j < links.length; j++){
      var link = links[j];
      try{
        var url = new URL(link.href);
        if(url.hostname === 'ecomgraduates.com'){
          url.searchParams.set('ref', refParam);
          link.href = url.href;
        }
      } catch(e){}
    }
  }
}
/* addRefParamToUrlsAndSetCookie(); */


/* ══ 9. RTL FIX (demo) ══════════════════════════════════ */
document.querySelectorAll('[href="/ar"]').forEach(function(link){
  link.setAttribute('target', '_blank');
});


/* ══ 10. NEWSLETTER POPUP — open on CTA click ═══════════
   Intercepts any <a href="#newsletter-popup-modal"> and
   fires the Bootstrap modal instead of a scroll jump.
   ════════════════════════════════════════════════════════ */
document.addEventListener('click', function(e) {
  var a = e.target.closest('a[href="#newsletter-popup-modal"]');
  if (!a) return;
  e.preventDefault();
  var modalEl = document.querySelector('#newsletter-popup-modal');
  if (!modalEl) return;
  var modal = bootstrap.Modal.getOrCreateInstance(modalEl);
  modal.show();
});

/* ===========================================================
   Parche: Carrusel destacados (enigma-marquee) — clic en la
   tarjeta navega al producto. La versión de la sección en el
   store usa setPointerCapture, que hace que el 'click' reporte
   el viewport y su handler no encuentre la tarjeta → no navega.
   Aquí capturamos la tarjeta en 'pointerdown' (antes de la
   captura) y navegamos en 'pointerup' si NO hubo arrastre.
   =========================================================== */
(function () {
  var SEL = 'enigma-marquee .em-card[data-url]';
  var card = null, sx = 0, sy = 0, moved = 0, down = false, onLink = false;

  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    card = (t && t.closest) ? t.closest(SEL) : null;
    if (!card) { down = false; return; }
    down = true; sx = e.clientX; sy = e.clientY; moved = 0;
    onLink = !!(t.closest('a, button'));
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!down) return;
    var d = Math.abs(e.clientX - sx) + Math.abs(e.clientY - sy);
    if (d > moved) moved = d;
  }, true);

  document.addEventListener('pointerup', function (e) {
    if (!down) return;
    down = false;
    if (!card || moved > 8 || onLink) return;   // arrastre o clic en enlace nativo → no forzar
    var url = card.dataset.url;
    if (url) { window.location.href = url; }
  }, true);
})();


/* ──────────────────────────────────────────────────────────────────
   WHEELIO EN MOVIL: marca el <html> mientras el popup esta abierto.

   El CSS de custom.css hace el resto. Aqui solo se decide cuando esta
   abierto, que no es evidente: Wheelio no pone ninguna clase "activa". Deja
   el holder en el DOM y lo aparca con `prepared` (fuera de pantalla, opacidad
   0.001) o `wlo_hidden`. Abierto = existe y no lleva ninguna de las dos.

   Se vigila tambien childList: el holder se inyecta despues de cargar la
   pagina, y un observador solo de atributos no se entera de que aparece.
   ────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function abierto() {
    var h = document.querySelector('.wheelio_holder');
    if (!h) return false;
    return !h.classList.contains('prepared') && !h.classList.contains('wlo_hidden');
  }

  var pendiente = false;
  function sync() {
    pendiente = false;
    document.documentElement.classList.toggle('wlo-abierto', abierto());
  }

  /* El observador cubre todo el body y salta mucho. Agrupar en un frame
     evita recalcular la clase decenas de veces por segundo. */
  function pedirSync() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(sync);
  }

  function arrancar() {
    sync();
    new MutationObserver(pedirSync).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  if (document.body) arrancar();
  else document.addEventListener('DOMContentLoaded', arrancar);
})();


/* ──────────────────────────────────────────────────────────────────
   OPCIONES QUE NO EXISTEN: fuera del selector

   En el Cubrecama Blanco, "Super King" solo tiene 3 de los 6 disenos. Las
   otras 3 combinaciones NO existen como variante, pero el selector las
   pintaba igual: el cliente elegia un circulo y no pasaba nada.

   El tema no lo cubre. El bloque de tallas calcula `option_disabled` en
   Liquid, pero con la variante inicial, asi que se queda viejo en cuanto
   cambias de diseno. Los circulos de color no lo calculan en absoluto.

   Aqui se recalcula en cada cambio, para los dos grupos:
     - combinacion que NO existe  -> se oculta
     - existe pero esta agotada   -> se deja, marcada por el tema. Que algo
       este agotado es informacion util; que no exista, no.
   ────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function grupos(raiz) {
    return Array.prototype.slice.call(raiz.querySelectorAll('.product-option-wrapper'));
  }

  /* El valor elegido de un grupo, sea radio o desplegable. */
  function valorDe(grupo) {
    var sel = grupo.querySelector('select.product-option');
    if (sel) return sel.value;
    var r = grupo.querySelector('input.product-option:checked');
    return r ? r.value : null;
  }

  /* Cada opcion del grupo con el nodo que hay que ocultar. En los radios es
     el <li> que lo envuelve; en el desplegable, el propio <option>. */
  function opcionesDe(grupo) {
    var sel = grupo.querySelector('select.product-option');
    if (sel) {
      return Array.prototype.map.call(sel.options, function (o) {
        return { valor: o.value, nodo: o, esOption: true };
      });
    }
    return Array.prototype.map.call(
      grupo.querySelectorAll('input.product-option'),
      function (r) { return { valor: r.value, nodo: r.closest('li') || r, input: r }; }
    );
  }

  function existe(combo) {
    var vs = window.productVariants || [];
    for (var i = 0; i < vs.length; i++) {
      if (JSON.stringify(vs[i].options) === JSON.stringify(combo)) return true;
    }
    return false;
  }

  var recalculando = false;

  function repasar(raiz) {
    if (recalculando || !window.productVariants) return;
    var gs = grupos(raiz);
    if (gs.length < 2) return;   // con una sola opcion no hay combinaciones imposibles

    var actual = gs.map(valorDe);
    var hayQueReelegir = null;

    gs.forEach(function (grupo, i) {
      opcionesDe(grupo).forEach(function (op) {
        var combo = actual.slice();
        combo[i] = op.valor;
        var ok = existe(combo);

        if (op.esOption) {
          op.nodo.hidden = !ok;
          op.nodo.disabled = !ok;
        } else {
          op.nodo.style.display = ok ? '' : 'none';
        }

        /* Si lo que estaba elegido ha dejado de existir --pasa al cambiar de
           talla-- hay que mover la seleccion o el formulario se queda sin
           variante y el boton de compra no sabe que mandar. */
        if (!ok && op.valor === actual[i] && hayQueReelegir === null) {
          hayQueReelegir = { grupo: i, opciones: opcionesDe(grupo) };
        }
      });
    });

    if (!hayQueReelegir) return;

    var i = hayQueReelegir.grupo;
    for (var j = 0; j < hayQueReelegir.opciones.length; j++) {
      var op = hayQueReelegir.opciones[j];
      var combo = actual.slice();
      combo[i] = op.valor;
      if (!existe(combo)) continue;

      recalculando = true;
      if (op.esOption) {
        var sel = gs[i].querySelector('select.product-option');
        sel.value = op.valor;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (op.input) {
        op.input.checked = true;
        op.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      recalculando = false;
      repasar(raiz);
      return;
    }
  }

  function arrancar() {
    var raices = document.querySelectorAll('.product-variant-selector');
    Array.prototype.forEach.call(raices, function (raiz) {
      repasar(raiz);
      raiz.addEventListener('change', function () {
        /* Al final de la cola: el tema tambien escucha este change y conviene
           que termine antes de recalcular. */
        setTimeout(function () { repasar(raiz); }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();
